export const JSONtoCSV = (data: any[]) => {
  if (!data || data.length === 0) {
    return "";
  }
  
  const replace = (key, value) => value === null ? '' : value; 
  const headers = Object.keys(data[0]); 

  const csv = [
    headers.join(','),
    ...data.map(row => headers.map(value => JSON.stringify(row[value], replace)).join(','))
  ].join('\r\n'); 

  return csv; 
};
